import React, { Component } from "react";
import { connect } from "react-redux";
import ProductHeader from "../ProductDetails/ProductHeader";

import { TextField, Button } from "@material-ui/core";
import ActionButton from "../ActionButton";
import { ReactComponent as Logo } from "./assets/lounge.svg";
import instance from "../../store/actions/instance";
import CircularProgress from "@material-ui/core/CircularProgress";
import { ReactComponent as Error } from "../CheckoutProcess/assets/close.svg";

export class index extends Component {
  state = {
    tracking_id: "",
    loading: false,
    failed: false,
  };
  componentDidMount() {
    window.scrollTo(0, document.body.scrollHeight);
  }
  handleClick = async () => {
    this.setState({ loading: true, failed: false });
    let request = await instance.get(
      `/api/waiting/track?tracking_id=${this.state.tracking_id}&waiting_list=${this.props.history.location.state.waiting_list.id}`
    );

    request = request.data;

    if (request.success) {
      this.props.history.push({
        pathname: "/waitlist/status/",
        state: {
          data: request.data[0],
          tracking_id: this.state.tracking_id,
          waiting_list: this.props.history.location.state.waiting_list,
        },
      });
    } else {
      this.setState({ failed: true, loading: false });
    }
  };
  render() {
    if (!this.props.history.location.state) this.props.history.replace("/");
    const language = this.props.language;

    return (
      <div style={{ backgroundColor: "white" }} className="h-100">
        <ProductHeader
          style={{ backgroundColor: "white" }}
          onBack={() =>
            this.props.history.goBack({
              waiting_list: this.props.history.location.state.waiting_list,
            })
          }
        />
        <div
          className="free-space-58"
          style={{ backgroundColor: "white" }}
        ></div>

        <div style={{ marginTop: "55px" }}>
          <Logo width="100" height="100" className="mt-4" />
          <p className="text-muted mt-5 mb-0" style={{ fontSize: 22 }}>
            {language == "english"
              ? "Enter Your Tracking ID"
              : "ادخل رقم التتبع"}
          </p>

          <div className="w-75 mx-auto mb-5 ">
            <TextField
              key="textField-waitlist-name"
              id="standard-basic"
              fullWidth
              InputLabelProps={{
                style: {
                  right: language == "arabic" && 5,
                  left: language == "arabic" && "auto",
                },
                dir: language == "english" ? "ltr" : "rtl",
              }}
              InputProps={{
                dir: language == "english" ? "ltr" : "rtl",
              }}
              color="primary"
              className=""
              onChange={(e) =>
                this.setState({
                  tracking_id: e.target.value,
                })
              }
              name="tracking_id"
              value={this.state.tracking_id}
              FormHelperTextProps={{
                style: {
                  textAlign: language == "arabic" && "right",
                  marginRight: language == "arabic" && 5,
                },
              }}
            />
            {this.state.loading && (
              <CircularProgress size={25} style={{ position: "absolute" }} />
            )}
            {this.state.failed && (
              <Error width={20} height={25} style={{ position: "absolute" }} />
            )}
          </div>
          <Button
            className="mt-5 text-left"
            color="secondary"
            variant="outlined"
            onClick={() =>
              this.props.history.goBack({
                waiting_list: this.props.history.location.state.waiting_list,
              })
            }
          >
            {language === "english"
              ? "Not in the Waiting List?"
              : "لست في قائمة الإنتظار؟"}
          </Button>
          <div
            className="free-space-115"
            style={{ backgroundColor: "white" }}
          ></div>
        </div>
        <ActionButton
          onClick={() => this.handleClick()}
          action={this.props.language == "english" ? "Check" : "تحقق"}
          allowWithMenu
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(index);
